import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ValidatePasswordResetToken } from "../services/authAPI"; // Adjust the import path as necessary
import { Typography, Box } from "@mui/material";

function ValidateResetToken() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // Extract the token from the URL
  const navigate = useNavigate();
  const [status, setStatus] = useState("Validating token..."); // Initial status
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const validateToken = async (e) => {

      setStatus("Validating token..."); // Update status message


      if (!token) {
        console.error("No token provided in the URL.");
        return;
      }   

      setLoading(true);
  
      try {

        await ValidatePasswordResetToken(token);
        setSuccess("Token successfully validated");
        setTimeout(() => navigate(`/reset-password?token=${token}`), 3000);
      } catch (err) {
        setError(err.message || "Failed to reset password.");
      } finally {
        setLoading(false);
      }
      
    };

    validateToken();
  }, [token, navigate]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      textAlign="center"
    >
      <Typography variant="h6">{status}</Typography>
    </Box>
  );
}

export default ValidateResetToken;